<template>
  <div class="page-wrapper bg-light">
    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="lightboxImgs"
      :index="lightboxIndex"
      @hide="onHideLightbox"
    ></vue-easy-lightbox>

    <div class="content container-fluid">
      <div class="page-header mb-4">
        <div class="row align-items-center justify-content-between">
          <div class="col-md-5 mb-3 mb-md-0">
            <h3 class="page-title text-dark font-weight-bold mb-1">
              Quản Lý Phản Ánh & Kiến Nghị
            </h3>
            <ul class="breadcrumb bg-transparent p-0 m-0">
              <li class="breadcrumb-item">
                <router-link to="/" class="text-muted text-decoration-none"
                  >Dashboard</router-link
                >
              </li>
              <li class="breadcrumb-item active">
                Quản lý Phản ánh & kiến nghị
              </li>
            </ul>
          </div>

          <div
            class="col-md-7 d-flex flex-wrap justify-content-md-end align-items-center"
          >
            <button
              class="btn btn-white shadow-sm mr-2 font-weight-medium"
              @click="showFilterModal = true"
            >
              <i class="fa fa-filter text-primary mr-1"></i> Tìm kiếm & Lọc
              <span v-if="isFiltering" class="badge badge-primary ml-1">!</span>
            </button>

            <div class="btn-group shadow-sm mr-2 bg-white rounded">
              <button
                type="button"
                class="btn btn-view"
                :class="{ active: viewMode === 'grid' }"
                @click="viewMode = 'grid'"
                title="Dạng lưới"
              >
                <i class="fa fa-th-large"></i>
              </button>
              <button
                type="button"
                class="btn btn-view"
                :class="{ active: viewMode === 'list' }"
                @click="viewMode = 'list'"
                title="Dạng danh sách"
              >
                <i class="fa fa-list"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showFilterModal"
        class="custom-modal-backdrop"
        @click.self="showFilterModal = false"
      >
        <div
          class="custom-modal-dialog animate-pop-in"
          style="max-width: 500px"
        >
          <div class="modal-content border-0">
            <div class="modal-header border-bottom-0 pb-0">
              <h5 class="modal-title font-weight-bold">Tìm kiếm & Sắp xếp</h5>
              <button
                type="button"
                class="close-btn"
                @click="showFilterModal = false"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="modal-body p-4">
              <div class="form-group mb-3">
                <label class="font-weight-bold small text-muted">Từ khóa</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-light border-0"
                      ><i class="fa fa-search"></i
                    ></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-light border-0"
                    placeholder="Nhập tiêu đề hoặc nội dung..."
                    v-model="filters.keyword"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 form-group mb-3">
                  <label class="font-weight-bold small text-muted"
                    >Trạng thái</label
                  >
                  <select
                    class="form-control custom-select bg-light border-0"
                    v-model="filters.status"
                  >
                    <option value="ALL">Tất cả</option>
                    <option value="MOI_GUI">Mới gửi</option>
                    <!-- <option value="DA_XEM">Đã xem</option> -->
                    <option value="DANG_XU_LY">Đang xử lý</option>
                    <option value="DA_GIAI_QUYET">Đã giải quyết</option>
                    <option value="TU_CHOI">Từ chối</option>
                  </select>
                </div>
                <div class="col-md-6 form-group mb-3">
                  <label class="font-weight-bold small text-muted"
                    >Danh mục</label
                  >
                  <select
                    class="form-control custom-select bg-light border-0"
                    v-model="filters.categoryId"
                  >
                    <option :value="null">Tất cả</option>
                    <option
                      v-for="cat in listCategories"
                      :key="cat.id"
                      :value="cat.id"
                    >
                      {{ cat.tenDanhMuc }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group mb-4">
                <label class="font-weight-bold small text-muted"
                  >Sắp xếp theo</label
                >
                <select
                  class="form-control custom-select bg-light border-0"
                  v-model="filters.sort"
                >
                  <option value="ngayTao,desc">Mới nhất trước</option>
                  <option value="ngayTao,asc">Cũ nhất trước</option>
                </select>
              </div>

              <div class="d-flex">
                <button
                  class="btn btn-light flex-grow-1 mr-2"
                  @click="resetFilters"
                >
                  <i class="fa fa-undo mr-1"></i> Đặt lại
                </button>
                <button
                  class="btn btn-primary flex-grow-1"
                  @click="applyFilters"
                >
                  Áp dụng tìm kiếm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-md-3 col-sm-6 mb-3 mb-md-0">
          <div
            class="card border-0 shadow-sm card-stat bg-primary text-white h-100 overflow-hidden"
          >
            <div class="card-body position-relative">
              <div class="stat-icon"><i class="fa fa-files-o"></i></div>
              <h3 class="mb-1 font-weight-bold">{{ stats.total }}</h3>
              <div class="small opacity-75 font-weight-bold text-uppercase">
                Tổng báo cáo
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 mb-3 mb-md-0">
          <div
            class="card border-0 shadow-sm card-stat bg-warning text-white h-100 overflow-hidden"
          >
            <div class="card-body position-relative">
              <div class="stat-icon"><i class="fa fa-bell-o"></i></div>
              <h3 class="mb-1 font-weight-bold">{{ stats.new }}</h3>
              <div class="small opacity-75 font-weight-bold text-uppercase">
                Cần xử lý (Mới)
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 mb-3 mb-md-0">
          <div
            class="card border-0 shadow-sm card-stat bg-success text-white h-100 overflow-hidden"
          >
            <div class="card-body position-relative">
              <div class="stat-icon"><i class="fa fa-check-circle-o"></i></div>
              <h3 class="mb-1 font-weight-bold">{{ stats.completed }}</h3>
              <div class="small opacity-75 font-weight-bold text-uppercase">
                Đã hoàn thành
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div
            class="card border-0 shadow-sm card-stat bg-info text-white h-100 overflow-hidden"
          >
            <div class="card-body position-relative">
              <div class="stat-icon"><i class="fa fa-clock-o"></i></div>
              <h3 class="mb-1 font-weight-bold">{{ stats.processing }}</h3>
              <div class="small opacity-75 font-weight-bold text-uppercase">
                Đang xử lý
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div
        v-else-if="listBaoCao.length === 0"
        class="text-center py-5 empty-state"
      >
        <div class="empty-icon-wrapper mb-3">
          <i class="fa fa-search"></i>
        </div>
        <h5 class="text-dark font-weight-bold">Không tìm thấy báo cáo nào</h5>
        <p class="text-muted">
          Thử thay đổi bộ lọc trạng thái để xem kết quả khác.
        </p>
      </div>

      <div v-else>
        <transition name="fade" mode="out-in">
          <div v-if="viewMode === 'grid'" key="grid" class="row">
            <div
              class="col-md-6 col-lg-4 d-flex align-items-stretch mb-4"
              v-for="item in listBaoCao"
              :key="item.id"
            >
              <div
                class="card modern-card w-100 border-0 h-100"
                @click="openDetail(item)"
              >
                <div class="card-body p-4 d-flex flex-column">
                  <div
                    class="d-flex justify-content-between align-items-start mb-3"
                  >
                    <span class="category-tag">
                      {{ item.tenDanhMuc }}
                    </span>
                    <span
                      class="status-dot"
                      :class="getStatusColorClass(item.trangThai)"
                      :title="getStatusLabel(item.trangThai)"
                    ></span>
                  </div>

                  <h5
                    class="card-title font-weight-bold text-dark mb-2 text-truncate-2"
                    :title="item.tieuDe"
                  >
                    {{ item.tieuDe }}
                  </h5>
                  <p
                    class="card-text text-muted small text-truncate-3 mb-3 flex-grow-1"
                  >
                    {{ item.noiDung }}
                  </p>

                  <div
                    v-if="item.danhSachAnh && item.danhSachAnh.length > 0"
                    class="img-preview-grid mb-3"
                  >
                    <div
                      v-for="(img, idx) in item.danhSachAnh.slice(0, 3)"
                      :key="idx"
                      class="img-thumb"
                    >
                      <img :src="img" />
                    </div>
                    <div v-if="item.danhSachAnh.length > 3" class="img-more">
                      +{{ item.danhSachAnh.length - 3 }}
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-between align-items-center mt-auto pt-3 border-top"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        :src="item.avatarNguoiGui || '/assets/img/user.jpg'"
                        class="avatar-circle-img mr-2"
                      />
                      <div class="d-flex flex-column">
                        <span
                          class="font-size-xs font-weight-bold text-dark text-truncate"
                          style="max-width: 90px"
                        >
                          {{ item.tenNguoiGui }}
                        </span>
                        <span class="font-size-xs text-muted">{{
                          formatDate(item.ngayTao)
                        }}</span>
                      </div>
                    </div>
                    <div
                      :class="['badge-pill', getStatusClass(item.trangThai)]"
                    >
                      {{ getStatusLabel(item.trangThai) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else key="list" class="list-layout">
            <div class="card border-0 shadow-sm rounded-lg overflow-hidden">
              <div class="list-group list-group-flush">
                <div
                  v-for="item in listBaoCao"
                  :key="item.id"
                  class="list-group-item list-group-item-action p-4 d-flex flex-column flex-md-row align-items-md-center justify-content-between cursor-pointer"
                  @click="openDetail(item)"
                >
                  <div
                    class="d-flex align-items-center mb-3 mb-md-0"
                    style="min-width: 220px"
                  >
                    <div class="position-relative mr-3">
                      <img
                        :src="item.avatarNguoiGui || '/assets/img/user.jpg'"
                        class="avatar-lg rounded-circle shadow-sm border"
                      />
                      <span
                        v-if="item.trangThai === 'MOI_GUI'"
                        class="new-indicator"
                      ></span>
                    </div>
                    <div class="overflow-hidden">
                      <h6 class="font-weight-bold text-dark mb-0 text-truncate">
                        {{ item.tenNguoiGui }}
                      </h6>
                      <div class="text-muted font-size-xs">
                        {{ formatDate(item.ngayTao) }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex flex-column mb-3 mb-md-0 flex-grow-1 px-md-4"
                    style="min-width: 0"
                  >
                    <div class="d-flex align-items-center mb-1">
                      <span
                        class="category-tag mr-2 py-0 px-2"
                        style="font-size: 0.7rem"
                        >{{ item.tenDanhMuc }}</span
                      >
                      <h6 class="font-weight-bold text-dark mb-0 text-truncate">
                        {{ item.tieuDe }}
                      </h6>
                    </div>
                    <p class="text-muted small mb-0 text-truncate">
                      {{ item.noiDung }}
                    </p>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between list-meta"
                    style="min-width: 140px; justify-content: flex-end"
                  >
                    <span
                      :class="['badge-pill', getStatusClass(item.trangThai)]"
                    >
                      {{ getStatusLabel(item.trangThai) }}
                    </span>
                    <i
                      class="fa fa-chevron-right text-muted ml-3 font-size-sm"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="totalPages > 1" class="row mt-4">
        <div class="col-md-12 d-flex justify-content-center">
          <nav aria-label="Page navigation">
            <ul class="pagination pagination-rounded">
              <li class="page-item" :class="{ disabled: currentPage === 0 }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage - 1)"
                >
                  <i class="fa fa-angle-left"></i>
                </a>
              </li>

              <li
                class="page-item"
                v-for="page in visiblePages"
                :key="page"
                :class="{
                  active: currentPage === page - 1,
                  disabled: page === '...',
                }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="page !== '...' && changePage(page - 1)"
                >
                  {{ page }}
                </a>
              </li>

              <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages - 1 }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage + 1)"
                >
                  <i class="fa fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div
      v-if="showModal"
      class="custom-modal-backdrop"
      @click.self="closeModal"
    >
      <div class="custom-modal-dialog modal-xl animate-pop-in">
        <div class="modal-content border-0 shadow-lg overflow-hidden">
          <div
            class="modal-header border-0 pb-0 pt-4 px-4 bg-white align-items-center"
          >
            <div>
              <span class="badge badge-light-secondary border mb-2"
                >#{{ selectedItem.id }}</span
              >
              <h4 class="modal-title font-weight-bold text-dark">
                Chi tiết & Xử lý báo cáo
              </h4>
            </div>
            <button type="button" class="close-btn" @click="closeModal">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="modal-body p-4">
            <div class="row">
              <div class="col-lg-8 border-right pr-lg-4">
                <div
                  class="meta-info-box d-flex align-items-center justify-content-between p-3 rounded mb-4"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="
                        selectedItem.avatarNguoiGui || '/assets/img/user.jpg'
                      "
                      class="avatar-circle mr-3"
                    />
                    <div>
                      <div class="small text-muted font-weight-medium">
                        Người gửi
                      </div>
                      <div class="font-weight-bold text-dark">
                        {{ selectedItem.tenNguoiGui }}
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center border-left pl-3">
                    <div
                      class="icon-circle bg-white text-primary shadow-sm mr-3"
                    >
                      <i class="fa fa-calendar"></i>
                    </div>
                    <div>
                      <div class="small text-muted font-weight-medium">
                        Thời gian
                      </div>
                      <div class="font-weight-bold text-dark">
                        {{ formatDate(selectedItem.ngayTao) }}
                      </div>
                    </div>
                  </div>

                  <div class="d-none d-md-block">
                    <span class="badge badge-outline-primary">{{
                      selectedItem.tenDanhMuc
                    }}</span>
                  </div>
                </div>

                <h5 class="text-dark font-weight-bold mb-2">
                  {{ selectedItem.tieuDe }}
                </h5>
                <div class="content-display mb-4">
                  {{ selectedItem.noiDung }}
                </div>

                <div
                  v-if="
                    selectedItem.danhSachAnh &&
                    selectedItem.danhSachAnh.length > 0
                  "
                >
                  <label
                    class="text-uppercase text-muted font-size-xs font-weight-bold mb-2"
                  >
                    <i class="fa fa-paperclip mr-1"></i> Hình ảnh đính kèm
                  </label>
                  <div class="row">
                    <div
                      class="col-md-3 col-4 mb-3"
                      v-for="(img, idx) in selectedItem.danhSachAnh"
                      :key="idx"
                    >
                      <div
                        class="attachment-card shadow-sm"
                        @click="showLightbox(selectedItem.danhSachAnh, idx)"
                      >
                        <img :src="img" class="attachment-img" />
                        <div class="attachment-overlay">
                          <i class="fa fa-search-plus"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 pl-lg-4">
                <div class="sticky-top" style="top: 20px">
                  <h6
                    class="text-uppercase text-muted font-weight-bold mb-3 section-title"
                  >
                    TRẠNG THÁI & TÁC VỤ
                  </h6>

                  <div class="status-display-box text-center p-3 rounded mb-3">
                    <div class="label-text mb-1">Hiện tại</div>
                    <div class="status-text font-weight-bold">
                      {{ getStatusLabel(selectedItem.trangThai) }}
                    </div>
                  </div>

                  <div class="action-buttons d-flex flex-column gap-2 mb-4">
                    <button
                      v-if="selectedItem.trangThai === 'MOI_GUI'"
                      class="btn btn-action btn-process shadow-sm"
                      @click="updateStatus('DANG_XU_LY')"
                    >
                      <i class="fa fa-play-circle mr-2"></i> Tiếp nhận xử lý
                    </button>

                    <template
                      v-if="
                        ['MOI_GUI', 'DANG_XU_LY'].includes(
                          selectedItem.trangThai
                        )
                      "
                    >
                      <button
                        class="btn btn-action btn-complete shadow-sm"
                        @click="updateStatus('DA_GIAI_QUYET')"
                      >
                        <i class="fa fa-check-circle mr-2"></i> Hoàn thành
                      </button>

                      <button
                        class="btn btn-action btn-reject"
                        @click="updateStatus('TU_CHOI')"
                      >
                        <i class="fa fa-times mr-2"></i> Từ chối
                      </button>
                    </template>

                    <div
                      v-if="
                        ['DA_GIAI_QUYET', 'TU_CHOI'].includes(
                          selectedItem.trangThai
                        )
                      "
                      class="text-center mt-2"
                    >
                      <span class="text-muted small"
                        ><i class="fa fa-lock mr-1"></i> Hồ sơ đã đóng.</span
                      >
                      <button
                        class="btn btn-link btn-sm text-primary p-0 ml-1 font-weight-bold"
                        @click="updateStatus('DANG_XU_LY')"
                      >
                        Mở lại?
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-12 pl-lg-4 history-section border-top pt-4 mt-4"
              >
                <h6
                  class="text-uppercase text-secondary font-weight-bold mb-4"
                  style="font-size: 0.75rem; letter-spacing: 1px"
                >
                  <i class="fa fa-history mr-2"></i>Tiến trình xử lý
                </h6>

                <div
                  v-if="
                    selectedItem.lichSuXuLy &&
                    selectedItem.lichSuXuLy.length > 0
                  "
                  class="activity-stream"
                >
                  <div
                    v-for="(log, index) in selectedItem.lichSuXuLy"
                    :key="log.id"
                    class="stream-item"
                  >
                    <div class="stream-icon">
                      <img
                        :src="log.avatarNguoiThucHien || '/assets/img/user.jpg'"
                        class="avatar-sm rounded-circle shadow-sm"
                      />
                    </div>

                    <div class="stream-content bg-light-card p-3 rounded mb-3">
                      <div
                        class="d-flex justify-content-between align-items-start mb-2"
                      >
                        <div>
                          <span class="font-weight-bold text-dark mr-1">{{
                            log.tenNguoiThucHien
                          }}</span>
                          <span class="text-muted small"
                            >đã {{ log.hanhDong.toLowerCase() }}</span
                          >
                        </div>
                        <small class="text-muted text-nowrap ml-2">
                          <i class="fa fa-clock-o mr-1"></i
                          >{{ formatDate(log.thoiGian) }}
                        </small>
                      </div>

                      <div
                        v-if="log.trangThaiCu && log.trangThaiMoi"
                        class="status-change-box my-2"
                      >
                        <span class="badge-status-text text-muted">{{
                          getStatusLabel(log.trangThaiCu)
                        }}</span>
                        <i
                          class="fa fa-arrow-right mx-2 text-primary small"
                        ></i>
                        <span
                          class="badge-status-text font-weight-bold"
                          :class="getTextColorClass(log.trangThaiMoi)"
                        >
                          {{ getStatusLabel(log.trangThaiMoi) }}
                        </span>
                      </div>

                      <div v-if="log.ghiChu" class="note-box mt-2">
                        <i class="fa fa-quote-left mr-2 opacity-50"></i>
                        <span>{{ log.ghiChu }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-else
                  class="text-center py-4 bg-light rounded text-muted"
                >
                  <div class="empty-icon-wrapper mb-3">
                    <i class="fa fa-folder-open-o"></i>
                  </div>
                  <p class="small mb-0">Chưa có hoạt động nào được ghi nhận.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, reactive } from "vue";
import baoCaoService from "@/services/gopYKienNghiService";
import VueEasyLightbox from "vue-easy-lightbox";
import { useToast } from "vue-toastification";
import Swal from "sweetalert2";

const showFilterModal = ref(false);

const toast = useToast();
const listBaoCao = ref([]);
const listCategories = ref([]);
const isLoading = ref(true);
const showModal = ref(false);
const selectedItem = ref(null);

const savedViewMode = localStorage.getItem("reportViewMode");
const viewMode = ref(savedViewMode || "grid");
watch(viewMode, (newVal) => {
  localStorage.setItem("reportViewMode", newVal);
});

const currentPage = ref(0);
const pageSize = ref(9);
const totalPages = ref(0);
const totalElements = ref(0);

const isFiltering = computed(() => {
  return (
    filters.keyword !== "" ||
    filters.status !== "ALL" ||
    filters.categoryId !== null
  );
});
const applyFilters = () => {
  currentPage.value = 0; // Reset về trang 1
  fetchData(); // Gọi lại hàm lấy dữ liệu
  showFilterModal.value = false; // Đóng modal
};

const resetFilters = () => {
  filters.keyword = "";
  filters.status = "ALL";
  filters.categoryId = null;
  filters.sort = "ngayTao,desc";

  // Reset xong thì tự động load lại luôn
  applyFilters();
};

const filters = reactive({
  keyword: "",
  status: "ALL", // Mặc định là ALL để logic if chạy đúng
  categoryId: null,
  sort: "ngayTao,desc",
});

// Lightbox props
const lightboxVisible = ref(false);
const lightboxImgs = ref([]);
const lightboxIndex = ref(0);

// --- Stats Computed ---
const stats = ref({
  total: 0,
  new: 0,
  processing: 0,
  completed: 0,
});

const fetchStats = async (params) => {
  try {
    const res = await baoCaoService.getStatistics(params);
    if (res.data) {
      stats.value = {
        total: res.data.total,
        new: res.data.newReports, // Backend trả về newReports
        processing: res.data.processing,
        completed: res.data.completed,
      };
    }
  } catch (e) {
    console.error("Lỗi tải thống kê:", e);
  }
};

// --- Fetch Data ---
const fetchData = async () => {
  isLoading.value = true;
  try {
    // 1. Tải danh mục nếu chưa có (để hiển thị vào dropdown lọc)
    if (listCategories.value.length === 0) {
      try {
        const catRes = await baoCaoService.getDanhMucActive();
        listCategories.value = catRes.data;
      } catch (e) {}
    }

    // 2. Chuẩn bị tham số chuẩn gửi lên Server
    const params = {
      page: currentPage.value,
      size: pageSize.value,
      sort: filters.sort,
      tuKhoa: filters.keyword || null,
      danhMucId: filters.categoryId || null,
    };

    if (filters.status && filters.status !== "ALL") {
      params.trangThai = filters.status;
    }

    // 3. Gọi API (Lưu ý: Service phải hỗ trợ nhận params)
    const res = await baoCaoService.getManagerReports(params);
    fetchStats(params);
    // 4. Xử lý kết quả phân trang
    if (res.data && res.data.content) {
      listBaoCao.value = res.data.content;
      totalPages.value = res.data.totalPages;
      totalElements.value = res.data.totalElements;
    } else {
      listBaoCao.value = res.data; // Fallback
    }
  } catch (e) {
    console.error(e);
    // toast.error("Lỗi tải dữ liệu");
  } finally {
    isLoading.value = false;
  }
};

// Chuyển trang
const changePage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchData();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};

// Logic hiển thị số trang (1, 2 ... 5 6 ... 10)
const visiblePages = computed(() => {
  const delta = 2;
  const range = [];
  const rangeWithDots = [];
  let l;

  for (let i = 1; i <= totalPages.value; i++) {
    if (
      i == 1 ||
      i == totalPages.value ||
      (i >= currentPage.value + 1 - delta && i <= currentPage.value + 1 + delta)
    ) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(i);
    l = i;
  }
  return rangeWithDots;
});

// --- Actions ---
const openDetail = (item) => {
  selectedItem.value = { ...item };
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  setTimeout(() => {
    selectedItem.value = null;
  }, 300);
};

const updateStatus = async (newStatus) => {
  const isReject = newStatus === "TU_CHOI";
  const confirm = await Swal.fire({
    title: isReject ? "Từ chối báo cáo?" : "Xác nhận thay đổi?",
    text: isReject
      ? "Vui lòng nhập lý do từ chối để nhân viên được biết:"
      : `Bạn muốn chuyển trạng thái sang "${getStatusLabel(newStatus)}"?`,
    icon: isReject ? "warning" : "question",

    input: isReject ? "textarea" : undefined,
    inputPlaceholder: "Nhập lý do từ chối...",
    inputValidator: (value) => {
      if (isReject && !value) {
        return "Bạn bắt buộc phải nhập lý do!";
      }
    },

    showCancelButton: true,
    confirmButtonColor: isReject ? "#d33" : "#3085d6",
    confirmButtonText: "Xác nhận",
    cancelButtonText: "Hủy",
  });

  if (confirm.isConfirmed) {
    const ghiChu = confirm.value;
    try {
      const dataUpdateStatus = await baoCaoService.updateStatus(
        selectedItem.value.id,
        newStatus,
        ghiChu
      );
      toast.success("Cập nhật thành công!");
      selectedItem.value = dataUpdateStatus.data;

      fetchData();
    } catch (error) {
      toast.error("Cập nhật thất bại.");
    }
  }
};

// --- Helpers ---
const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const getStatusLabel = (status) => {
  const map = {
    MOI_GUI: "Mới gửi",
    DANG_XU_LY: "Đang xử lý",
    DA_GIAI_QUYET: "Hoàn thành",
    TU_CHOI: "Từ chối",
  };
  return map[status] || status;
};

const getStatusClass = (status) => {
  const map = {
    MOI_GUI: "pill-primary",
    DA_XEM: "pill-info",
    DANG_XU_LY: "pill-warning",
    DA_GIAI_QUYET: "pill-success",
    TU_CHOI: "pill-danger",
  };
  return map[status] || "pill-secondary";
};

// Hàm lấy màu cho chấm tròn (Status Dot)
const getStatusColorClass = (status) => {
  const map = {
    MOI_GUI: "bg-primary",
    DA_XEM: "bg-info",
    DANG_XU_LY: "bg-warning",
    DA_GIAI_QUYET: "bg-success",
    TU_CHOI: "bg-danger",
  };
  return map[status] || "bg-secondary";
};

// Colors for modal bg
const getBgSoftClass = (status) => {
  const map = {
    MOI_GUI: "bg-soft-primary",
    DANG_XU_LY: "bg-soft-warning",
    DA_GIAI_QUYET: "bg-soft-success",
    TU_CHOI: "bg-soft-danger",
  };
  return map[status] || "bg-soft-secondary";
};
const getTextColorClass = (status) => {
  const map = {
    MOI_GUI: "text-primary",
    DANG_XU_LY: "text-warning",
    DA_GIAI_QUYET: "text-success",
    TU_CHOI: "text-danger",
  };
  return map[status] || "text-secondary";
};

// Lightbox
const showLightbox = (imgs, idx) => {
  lightboxImgs.value = imgs;
  lightboxIndex.value = idx;
  lightboxVisible.value = true;
};
const onHideLightbox = () => {
  lightboxVisible.value = false;
};

onMounted(() => fetchData());
</script>

<style scoped>
/* --- Page Layout --- */
.page-wrapper {
  min-height: 100vh;
  padding-bottom: 40px;
}

/* --- Stats Cards --- */
.card-stat {
  border-radius: 12px;
  transition: transform 0.2s;
}
.card-stat:hover {
  transform: translateY(-3px);
}
.stat-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 3rem;
  opacity: 0.2;
}

/* --- View Switcher & Toolbar --- */
.btn-view {
  border: 1px solid transparent;
  color: #999;
  padding: 8px 14px;
  background: white;
  transition: all 0.2s;
}
.btn-view:hover {
  color: #333;
  background: #f8f9fa;
}
.btn-view.active {
  color: #4a6cf7;
  background: #eef2ff;
  font-weight: bold;
}
.btn-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
}
.custom-select:focus,
.btn-white:focus {
  box-shadow: none;
  border-color: #4a6cf7;
}

/* --- GRID CARD STYLES (MATCHING USER HISTORY) --- */
.modern-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;
  overflow: hidden;
}
.modern-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}
.category-tag {
  background-color: #f3f6f9;
  color: #5e6278;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.avatar-circle-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}
.img-preview-grid {
  display: flex;
  gap: 4px;
}
.img-thumb,
.img-more {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
}
.img-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.img-more {
  background: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
}

/* --- LIST VIEW STYLES (MATCHING USER HISTORY) --- */
.list-group-item {
  border: none;
  border-bottom: 1px solid #f0f2f5;
  transition: background-color 0.2s;
}
.list-group-item:last-child {
  border-bottom: none;
}
.list-group-item:hover {
  background-color: #fbfbfb;
}
.avatar-lg {
  width: 48px;
  height: 48px;
  object-fit: cover;
}
.new-indicator {
  width: 10px;
  height: 10px;
  background: #ff0000;
  border: 2px solid white;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
}

/* --- STATUS PILLS --- */
.badge-pill {
  padding: 6px 12px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.pill-primary {
  background: #e1f0ff;
  color: #3699ff;
}
.pill-info {
  background: #e0f7fa;
  color: #00bcd4;
}
.pill-warning {
  background: #fff4de;
  color: #ffa800;
}
.pill-success {
  background: #e8fff3;
  color: #1bc5bd;
}
.pill-danger {
  background: #ffe2e5;
  color: #f64e60;
}
.pill-secondary {
  background: #f3f6f9;
  color: #7e8299;
}
.bg-primary {
  background-color: #3699ff !important;
}
.bg-info {
  background-color: #00bcd4 !important;
}
.bg-warning {
  background-color: #ffa800 !important;
}
.bg-success {
  background-color: #1bc5bd !important;
}
.bg-danger {
  background-color: #f64e60 !important;
}

/* --- Modal Layout --- */
.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.custom-modal-dialog {
  width: 100%;
  max-width: 1100px;
  background: white;
  border-radius: 16px;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
}
/* Để modal scroll được nếu nội dung dài */
.modal-content {
  max-height: 100%;
  display: flex;
  flex-direction: column;
}
.modal-body {
  overflow-y: auto;
}

.close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #f1f5f9;
  color: #64748b;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-btn:hover {
  background: #e2e8f0;
  color: #dc2626;
}

/* --- Left Column Styles --- */
.meta-info-box {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
}
.avatar-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
.icon-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content-display {
  color: #334155;
  line-height: 1.6;
  white-space: pre-wrap;
  font-size: 0.95rem;
}
.badge-light-secondary {
  background: #f1f5f9;
  color: #64748b;
  font-size: 0.8rem;
}
.badge-outline-primary {
  border: 1px solid #3b82f6;
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.05);
  padding: 5px 10px;
  border-radius: 6px;
}

/* --- Right Column Styles --- */
.section-title {
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}
.status-display-box {
  background-color: #eff6ff;
  border: 1px solid transparent;
}
.status-display-box .label-text {
  color: #ef4444;
  font-weight: 600;
  font-size: 0.85rem;
}
.status-display-box .status-text {
  color: #ef4444;
  font-size: 1.2rem;
}

/* Action Buttons */
.gap-2 {
  gap: 0.75rem;
}
.btn-action {
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.2s;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-process {
  background-color: #f59e0b;
  color: white;
}
.btn-process:hover {
  background-color: #d97706;
  transform: translateY(-2px);
}
.btn-complete {
  background-color: #10b981;
  color: white;
}
.btn-complete:hover {
  background-color: #059669;
  transform: translateY(-2px);
}
.btn-reject {
  background-color: white;
  color: #ef4444;
  border: 1px solid #ef4444;
}
.btn-reject:hover {
  background-color: #fef2f2;
}

/* --- TIMELINE HISTORY STYLES (MỚI) --- */
.timeline-container {
  position: relative;
  padding-left: 10px;
  border-left: 2px solid #e2e8f0;
  margin-left: 5px;
}
.timeline-item {
  position: relative;
  padding-bottom: 25px;
}
.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-marker {
  position: absolute;
  left: -16px; /* Canh giữa đường kẻ dọc */
  top: 5px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #cbd5e1;
  z-index: 1;
}
.timeline-item:first-child .timeline-marker {
  border-color: #3b82f6; /* Highlight mục mới nhất */
  background: #3b82f6;
}

.avatar-xs {
  width: 24px;
  height: 24px;
  object-fit: cover;
}
.log-action {
  font-size: 0.9rem;
}
.log-change {
  font-size: 0.8rem;
  padding: 4px 8px;
  display: inline-block;
  background: #f8fafc;
  border-radius: 4px;
}
.font-size-xs {
  font-size: 0.75rem;
}

/* Attachments */
.attachment-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  height: 90px;
}
.attachment-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}
.attachment-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}
.attachment-card:hover .attachment-overlay {
  opacity: 1;
}
.attachment-overlay i {
  color: white;
  font-size: 1.2rem;
}

/* Utils */
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.text-truncate-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.bg-soft-primary {
  background: #e1f0ff;
}
.bg-soft-warning {
  background: #fff4de;
}
.bg-soft-success {
  background: #e8fff3;
}
.bg-soft-danger {
  background: #ffe2e5;
}

/* Animations */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.animate-pop-in {
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
/* Style cho các input trong Filter Modal */
.bg-light {
  background-color: #f8f9fa !important;
}
.border-0 {
  border: none !important;
}
.custom-select:focus,
.form-control:focus {
  box-shadow: none;
  background-color: #fff;
  border: 1px solid #e1e5eb !important;
}

/* Hiệu ứng modal nảy nhẹ */
.animate-pop-in {
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.empty-icon-wrapper {
  width: 80px;
  height: 80px;
  background: #f0f2f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 32px;
  color: #999;
}

.activity-stream {
  position: relative;
  padding-left: 24px; /* Khoảng cách cho đường kẻ dọc */
  border-left: 2px solid #eef2f7; /* Đường kẻ dọc mờ */
  margin-left: 12px;
}

.stream-item {
  position: relative;
  padding-bottom: 8px;
}

/* Icon Avatar nằm trên đường kẻ */
.stream-icon {
  position: absolute;
  left: -37px; /* Căn chỉnh avatar vào giữa đường kẻ */
  top: 0;
  width: 28px;
  height: 28px;
  background: #fff;
  padding: 2px; /* Viền trắng quanh avatar */
}
.stream-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Khối nội dung */
.stream-content {
  background-color: #f8f9fa; /* Nền xám rất nhẹ */
  border: 1px solid #f1f1f1;
  transition: all 0.2s;
  position: relative;
}
.stream-content:hover {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-color: #e1e1e1;
}

/* Mũi tên trỏ vào avatar (Optional - tạo cảm giác hội thoại) */
.stream-content::before {
  content: "";
  position: absolute;
  left: -6px;
  top: 10px;
  width: 10px;
  height: 10px;
  background-color: inherit; /* Giống màu nền cha */
  transform: rotate(45deg);
  border-left: 1px solid #f1f1f1; /* Khớp border */
  border-bottom: 1px solid #f1f1f1;
}
.stream-content:hover::before {
  background-color: #fff;
  border-color: #e1e1e1;
}

/* Hộp hiển thị đổi trạng thái */
.status-change-box {
  background: #fff;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px dashed #d1d5db;
  display: inline-block;
  font-size: 0.85rem;
}

/* Ghi chú */
.note-box {
  font-style: italic;
  color: #913c39;
  font-size: 0.9rem;
  padding-top: 4px;
}

/* Màu text trạng thái */
.text-primary {
  color: #007bff !important;
}
.text-warning {
  color: #ffc107 !important;
}
.text-success {
  color: #28a745 !important;
}
.text-danger {
  color: #dc3545 !important;
}
.text-secondary {
  color: #6c757d !important;
}
</style>
